import { useEffect } from 'react';

export type IntersectionObserverConfig = {
  threshold: number | number[] | undefined;
  rootSelector: string;
  rootMargin: string | undefined;
  targetSelector: string;
  onIntersection: (intersectionRatio: number) => void;
};

export const useIntersectionObserver = (
  config: IntersectionObserverConfig
): void => {
  useEffect(() => {
    const {
      threshold,
      rootSelector,
      rootMargin,
      targetSelector,
      onIntersection,
    } = config;

    const observerInstance = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        const { intersectionRatio } = entry;

        onIntersection(intersectionRatio);
      },
      {
        root: document.querySelector(rootSelector),
        rootMargin,
        threshold,
      }
    );

    const targetEl = document.querySelector(targetSelector) as Element;
    observerInstance.observe(targetEl);

    return () => {
      observerInstance.disconnect();
    };
  }, [config]);
};
